export default __webpack_public_path__ + "static/media/eye.4b78d9f3.svg";